import { useState } from 'react'
import { formatInteger } from '../../utils/formatting'
import { CreateDoorProxyModal } from '../Modals/CompanyModal/CreateDoorProxyModal'
import { CollapsibleSection } from '../UI/CollapsibleSection/CollapsibleSection'
import { UnmatchedDoorsTable } from 'components/DataExpansionComponents/UnmatchedDoors/UnmatchedDoorsTable'
import { StandardSummaryResponse } from 'models/paginated-response'
import { FilterIdentifier } from 'models/saved_view'
import { IContactCompany } from 'models/contact_companies'

interface DoorMenuSectionProps {
  chainProxy?: IContactCompany
}

export function DoorProxySection(props: DoorMenuSectionProps) {
  const tableKey =
    'UNMATCHED_DOORS_TABLE_FOR_CHAIN_PROXY_' + props.chainProxy?.id
  const [totalRowsCount, setTotalRowsCount] = useState<StandardSummaryResponse>(
    {
      count: 0,
      alt_count: 0,
    }
  )
  return (
    <>
      <CollapsibleSection
        forceClose={totalRowsCount.alt_count < 1}
        summary={
          <div className={'w-full flex justify-between items-center'}>
            <div>
              Doors{' '}
              <span className={'font-thin'}>
                ({formatInteger(totalRowsCount.alt_count)})
              </span>
            </div>
            <CreateDoorProxyModal chainProxy={props.chainProxy} />
          </div>
        }
      >
        <UnmatchedDoorsTable
          tableKey={tableKey}
          filterIdentifierModifier={
            props.chainProxy?.id.toString() as FilterIdentifier
          }
          chainProxy={props.chainProxy}
          setTotalRowsCount={setTotalRowsCount}
        />
      </CollapsibleSection>
    </>
  )
}
